module.exports = __webpack_public_path__ + "img/playStore.26829051.png";